// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WFcVMB8EAYjYcMnq85i1gA\\=\\={font-weight:400 !important}.rzNjEgAz0x6m8K5gtGGRxw\\=\\={font-weight:500 !important}.sbePSN7E0Ex2BWzYTuYzgw\\=\\={font-weight:600 !important}.XfhM6TEtkt4tikuNLiBedQ\\=\\={margin:0 !important}", "",{"version":3,"sources":["webpack://./components/Typography/Title/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,0BAAA,CAEF,4BACE,0BAAA,CAEF,4BACE,0BAAA,CAEF,4BACE,mBAAA","sourcesContent":[".weight400 {\n  font-weight: 400 !important;\n}\n.weight500 {\n  font-weight: 500 !important;\n}\n.weight600 {\n  font-weight: 600 !important;\n}\n.noMargin {\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"weight400": "WFcVMB8EAYjYcMnq85i1gA==",
	"weight500": "rzNjEgAz0x6m8K5gtGGRxw==",
	"weight600": "sbePSN7E0Ex2BWzYTuYzgw==",
	"noMargin": "XfhM6TEtkt4tikuNLiBedQ=="
};
export default ___CSS_LOADER_EXPORT___;
